
import { defineComponent } from 'vue'
import TheCalculator from '@/components/TheCalculator.vue'
import { Calculator } from '@/modules/Calculator'
import { ThemeSwitcher } from '@/modules/ThemeSwitcher'
import ThemeBar from '@/components/ThemeBar.vue'

export default defineComponent({
  components: {
    ThemeBar,
    TheCalculator
  },
  data: () => ({
    calculator: new Calculator(),
    themeSwitcher: new ThemeSwitcher()
  })
})
